module.exports = __webpack_public_path__ + "static/lyft-b0febbfc3ef0f18f84165768683fe89d.jpg";